<template>
  <div>
    <dd style="margin:0 -15px 7px -35px;" v-if="imprintMethodModel.decorationMethod.supportVirtualDesign">
      <a href="javascript:;" @click="onStartDesign">
        <img src="https://img66.anypromo.com/frontimg/2025/Customize/Online-Studio-Banner.jpg"
          alt="Design Studio Banner" width="548" height="151">
      </a>
    </dd>
    <div class="mb-5">
      <button type="button" title="To ensure the best quality print, please send files in .ai and .eps formats"
        class="btn-select trans" :class="{
          'is-active':
            imprintMethodModel.decorationMethod.artworkType === 1
        }" @click="onArtworkTypeClick(1, false)">
        Upload logo
      </button>
      <button type="button" class="btn-select trans" :class="{
        'is-active': imprintMethodModel.decorationMethod.artworkType === 2
      }" @click="onArtworkTypeClick(2)">
        Email logo
      </button>
      <button type="button" class="btn-select trans" :class="{
        'is-active': imprintMethodModel.decorationMethod.artworkType === 3
      }" @click="onArtworkTypeClick(3)">
        Design for Me
      </button>
      <button type="button" class="btn-select trans" :class="{
        'is-active': imprintMethodModel.decorationMethod.artworkType === 5
      }" @click="onArtworkTypeClick(5)">
        Share Link
      </button>
    </div>

    <div v-if="imprintMethodModel.decorationMethod.artworkType === 1" class="artwork-option-item">
      <div style="overflow: hidden">
        <ap-button type="primary" size="mini" v-on:click="onSelectLogoFile"
          title="To ensure the best quality print, please send files in .ai and .eps formats">
          Choose your file
        </ap-button>

        <div class="artwork-list" v-if="
          imprintMethodModel.decorationMethod.selectedArtworkFiles.length > 0
        ">
          <dl v-for="(artwork, idx) in imprintMethodModel.decorationMethod
            .selectedArtworkFiles" :key="artwork.BoxNetFileSysNo">
            <dd class="artwork-preview">
              <img v-bind:src="artwork.ThumbnailUrl" :data-original="artwork.ThumbnailUrl" width="32" height="32" />
            </dd>
            <dd>
              {{
                artwork.FileName.length > 27
                  ? artwork.FileName.substring(0, 20) +
                  '...' +
                  artwork.FileName.substring(artwork.FileName.indexOf('.'))
                  : artwork.FileName
              }}
            </dd>
            <dd class="view">
              <div class="btn-groups">
                <ap-button type="default" text v-on:click="onArtworkPreview(artwork)">
                  View
                </ap-button>
                <ap-button type="default" text v-on:click="onArtworkRemove(idx)">
                  Delete
                </ap-button>
              </div>
            </dd>
          </dl>
        </div>
        <div class="virtual-effect" v-if="
          imprintMethodModel.decorationMethod.supportVirtualDesign &&
          imprintMethodModel.decorationMethod.virtualDesignImage != null
        ">
          <div class="virtual-effect__header">
            <h2>Virtual Effect</h2>
            <div class="view">
              <div class="btn-groups">
                <ap-button type="default" text v-on:click="onStartDesign">View</ap-button>
                <ap-button type="default" text v-on:click="onRemoveVirtualDesign">
                  Delete
                </ap-button>
              </div>
            </div>
          </div>
          <div>
            <div class="virtual-effect-cell" v-if="
              imprintMethodModel.decorationMethod.virtualDesignImage != null
            ">
              <img class="artwork-preview" :src="imprintMethodModel.decorationMethod.virtualDesignImage.Thumbnail
                " :data-original="imprintMethodModel.decorationMethod.virtualDesignImage.Thumbnail
                " width="32" height="32" />
              <span>{{
                imprintMethodModel.decorationMethod.virtualDesignImage.FileName
                  .length > 35
                  ? imprintMethodModel.decorationMethod.virtualDesignImage.FileName.substring(
                    0,
                    35
                  ) + '...'
                  : imprintMethodModel.decorationMethod.virtualDesignImage
                    .FileName
              }}</span>
            </div>
            <div class="virtual-effect-cell" v-if="
              imprintMethodModel.decorationMethod.virtualDesignLogo.length > 0
            ">
              <h3>Upload Files</h3>
              <div v-for="logo in imprintMethodModel.decorationMethod
                .virtualDesignLogo" :key="logo.SysNo">
                <img class="artwork-preview" :src="logo.Thumbnail" :data-original="logo.Thumbnail" width="32"
                  height="32" />
                <span>{{
                  logo.FileName.length > 35
                    ? logo.FileName.substring(0, 35) + '...'
                    : logo.FileName
                  }}</span>
              </div>
            </div>
            <div class="virtual-effect-cell" v-if="
              imprintMethodModel.decorationMethod.virtualDesignFonts.length > 0
            ">
              <h3>Font Used</h3>
              <div v-for="(font, n) in imprintMethodModel.decorationMethod
                .virtualDesignFonts" :key="n" :class="{ mt15: n > 0 }">
                <span class="font-text">{{ font.Text }}</span>
                <span class="font-fill">&lt;{{ font.Fill }}&gt;</span>
                <span class="font-family">&lt;{{ font.FontFamily }}&gt;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="imprintMethodModel.decorationMethod.artworkType == 2" class="artwork-option-item">
      To ensure the best quality print, send us files in .ai and .eps formats to
      <a href="mailto:art@anypromo.ca"><span>art@anypromo.ca</span></a>
    </div>
    <div style="padding-top: 5px; padding-bottom: 10px; font-size: 13px"
      v-else-if="imprintMethodModel.decorationMethod.artworkType == 3">
      Please leave instructions below. We will create your artwork for FREE!
    </div>
    <div v-else-if="imprintMethodModel.decorationMethod.artworkType == 5" class="artwork-option-item">
      <div style="color: red; ">
        Please make sure to grant us access to your project.
      </div>
      <div class="share-link">
        <textarea class="share-link__input" placeholder="Share Link" @input="handleShareLinkChange"
          v-model="imprintMethodModel.decorationMethod.shareLink"></textarea>
      </div>
    </div>

    <common-dialog :title="'Upload Logo'" :options="{ 'hideYesBt': true, 'hideCancelBt': true }"
      @on-cancel="() => { showArtWorkIframe = false }" v-show="showArtWorkIframe">

      <iframe :src="iframeSrc" frameborder="0" :width="iframeWidth" :height="iframeheight"></iframe>

    </common-dialog>

  </div>
</template>
<script setup lang="ts">
import { ref, type PropType } from 'vue'
import { ApButton } from '@anypromo/components-pc'
import { useExternal } from '../../composables/use-external'
import { ImprintMethodModel } from '../../model'
import { useApp } from '../../store/modules/app'
import { useImprintMethod } from '../../store/modules/imprintMethod'
import { useProductSpec } from '../../store/modules/productSpec'
import { type ArtworkFile } from '../../types'
import CommonDialog from '@anypromo/components-pc/AlertDialog/CommonDialog.vue'
const props = defineProps({
  imprintMethodModel: {
    type: Object as PropType<ImprintMethodModel>,
    default: {} as unknown
  }
})
const iframeWidth = ref(1020)
const iframeheight = ref(768)
const emit = defineEmits(['change', 'share-link-change', 'file-change', 'online-designed'])
const showArtWorkIframe = ref(false)
const iframeSrc = ref("")
const { GetIframeURL, openBoxFile, openOnlineDesigner } = useExternal()
const appState = useApp()
const productSpecState = useProductSpec()
const imprintMethodState = useImprintMethod()

const onArtworkTypeClick = (val: number, enableVirtualDesign?: boolean) => {
  const { imprintMethodModel } = props
  if (
    val === 1 &&
    enableVirtualDesign !== undefined &&
    imprintMethodModel.decorationMethod.supportVirtualDesign
  ) {
    imprintMethodModel.decorationMethod.isVirtualDesign = enableVirtualDesign
  }
  imprintMethodModel.decorationMethod.artworkType = val

  emit('change')
}

const onStartDesign = () => {
  const { imprintMethodModel } = props

  imprintMethodModel.decorationMethod.isVirtualDesign = true
  imprintMethodModel.decorationMethod.artworkType = 1
  emit('change')

  if (imprintMethodModel.decorationMethod) {
    openOnlineDesigner(
      imprintMethodModel.decorationMethod,
      productSpecState.getSelectedList,
      imprintMethodModel.decorationMethod.virtualDesignImage,
      imprintMethodModel.decorationMethod.virtualDesignJson
    ).then((data) => {
      if (imprintMethodModel.decorationMethod) {
        imprintMethodModel.decorationMethod.virtualDesignArts = [...data.arts]
        imprintMethodModel.decorationMethod.virtualDesignImage = data.design
        imprintMethodModel.decorationMethod.virtualDesignLogo = [...data.logo]
        imprintMethodModel.decorationMethod.virtualDesignFonts = [...data.fonts]
        imprintMethodModel.decorationMethod.virtualDesignJson = data.json
        emit('online-designed')
      }
    })
  }
}

const handleShareLinkChange = () => {
  emit('share-link-change')
}

const onSelectLogoFile = () => {
  const { imprintMethodModel } = props
  // 获得当前选中的
  const selectedIds = imprintMethodModel.decorationMethod.selectedArtworkFiles
    .map((f) => f.BoxNetFileSysNo)
    .join(',')

  const url = GetIframeURL('Customize',
    imprintMethodModel.decorationMethod.SysNo,
    1,
    -999999,
    '0',
    imprintMethodModel.decorationMethod,
    selectedIds)
  showArtWorkIframe.value = true
  iframeSrc.value = url
  const winWidth = window.innerWidth
  if (window.self !== window.top) {
    iframeWidth.value = 810
    iframeheight.value = 630
    //(window as any).openWindowS(url, 1092, 830);
  } else {
    if (winWidth < 1094) {
      iframeWidth.value = winWidth - 10
    }
  }

  openBoxFile().then((data) => {
    if (imprintMethodModel.decorationMethod) {
      showArtWorkIframe.value = false
      imprintMethodModel.decorationMethod.selectedArtworkFiles.push(...data)
    }
    emit('file-change')
    // notFilesError.value =
    //   imprintMethodModel.decorationMethod.selectedArtworkFiles.length === 0
  })
}

const onArtworkPreview = (val: ArtworkFile) => {
  //
  ; (window as any).openWindowS(val.PreviewUrl, 800, 700)
}

const onArtworkRemove = (index: number) => {
  const { imprintMethodModel } = props

  imprintMethodModel.decorationMethod.selectedArtworkFiles.splice(index, 1)
  emit('file-change')
}

const onRemoveVirtualDesign = () => {
  const { imprintMethodModel } = props
  if (imprintMethodModel.decorationMethod) {
    imprintMethodModel.decorationMethod.virtualDesignLogo.splice(0)
    imprintMethodModel.decorationMethod.virtualDesignImage = undefined
    imprintMethodModel.decorationMethod.virtualDesignJson = ''
    imprintMethodModel.decorationMethod.virtualDesignArts.splice(0)
    imprintMethodModel.decorationMethod.virtualDesignFonts.splice(0)
  }
}
</script>
<style lang="less">
.artwork-list {
  font-size: 13px;
  margin-top: 10px;
  width: 385px;
  display: table;

  dl {
    margin-top: 5px;
    margin-bottom: 0;
    display: table-row;

    &:first-child {
      margin-top: 0;
    }
  }

  dd {
    margin-right: 5px;
    vertical-align: middle;
    display: table-cell;

    &.view {
      width: 85px;
      padding-right: 5px;

      .btn-groups {
        display: flex;
        justify-content: space-between;
      }

      button {
        color: #4596ca;
        font-size: 13px;
        cursor: pointer;
        min-width: 0;

        &:focus {
          box-shadow: none;
        }
      }
    }
  }

  .artwork-preview {
    width: 40px;
    height: 32px;
    text-align: center;
  }

  .ap-button+.ap-button {
    margin-left: 6px;
  }

  .ap-button.is-text {
    padding-left: 0;
    padding-right: 0;
    min-width: unset;

    &:focus {
      box-shadow: none;
    }
  }
}

.virtual-effect {
  border: 1px solid #ddd;
  background: #f9f9f9;
  width: 385px;
  margin-top: 10px;

  &__header {
    background: #eee;
    padding: 5px 10px;
    padding-bottom: 4px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;

    .view {
      width: 80px;
    }

    .btn-groups {
      display: flex;
    }

    button {
      color: #4596ca;
      border: 0;
      background-color: transparent;
      padding-left: 15px;
      cursor: pointer;
      font-size: 13px;
      outline: none;

      &:focus {
        box-shadow: none;
      }
    }
  }

  h2 {
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
    margin: 0;
  }

  h3 {
    font-size: 13px;
    font-weight: 600;
    margin: 0;
    padding: 5px 0;
  }

  .font-text,
  .font-fill,
  .font-family {
    margin-right: 5px;
  }

  .virtual-effect-cell {
    padding: 0 0 10px 30px;
    font-size: 12px;

    &:first-child {
      padding: 10px;
      font-size: 15px;
    }

    .mt15 {
      margin-top: 15px;
    }

    img {
      vertical-align: middle;
      margin-right: 5px;
    }

    .font-text {
      display: block;
    }

    .font-text,
    .font-fill,
    .font-family {
      margin-right: 5px;
    }
  }
}

.share-link {
  padding-left: 18px;

  &__input {
    border-color: #cdcdcd;
    border-style: solid;
    border-width: 1px;
    padding: 5px;
    width: 100%;
    line-height: 24px;
    display: block;
    margin-top: 2px;
    margin-left: 1px;
    outline: none;
  }
}
</style>
